import { useState } from "react";
import { MailCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { sendVerification, errorDetail } from "@/lib/reader";

export default function VerifyEmailBanner({ email }) {
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await sendVerification();
      setSent(true);
    } catch (err) {
      toast.error(errorDetail(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-8 border border-[#e0982f]/40 bg-[#e0982f]/5 px-6 py-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-testid="account-verify-banner">
      <p className="flex items-start gap-3 text-sm">
        <MailCheck className="w-5 h-5 text-[#e0982f] shrink-0" />
        {sent
          ? <span data-testid="account-verify-sent">We've sent a confirmation link to <strong>{email}</strong>. Click it to finish.</span>
          : <span>Verify your email to see books and gifts you bought with this PayPal email while signed out.</span>}
      </p>
      {!sent && (
        <button onClick={send} disabled={busy} data-testid="account-verify-send" className="btn-ghost px-5 py-3 font-mono-ui text-xs uppercase tracking-[0.18em] flex items-center gap-2 shrink-0">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Send verification link
        </button>
      )}
    </div>
  );
}
